import type {
  Badge,
  ListBadgesResponse,
} from '@wix/ambassador-badges-v3-badge/types';
import { withResolvedError } from '@wix/members-area-commons-ts';

import type { ErrorHandler, HttpClient } from '../../types/controller';

type BadgesServiceOptions = {
  baseUrl: string;
  httpClient: HttpClient;
  errorHandler: ErrorHandler;
};

const BADGES_LIST_PAGING_LIMIT = 1000;

export class BadgesService {
  private readonly baseUrl: string;
  private readonly httpClient: HttpClient;
  private readonly errorHandler: ErrorHandler;

  constructor({ baseUrl, httpClient, errorHandler }: BadgesServiceOptions) {
    this.baseUrl = baseUrl;
    this.httpClient = httpClient;
    this.errorHandler = errorHandler;
  }

  readonly getBadgeList = async (): Promise<Badge[]> => {
    const badgesAcc: Badge[] = [];
    let page = 0;

    const requestFn =
      (offset: number = 0) =>
      () =>
        this.httpClient.get<ListBadgesResponse>(
          `${this.baseUrl}?paging.limit=${BADGES_LIST_PAGING_LIMIT}&paging.offset=${offset}`,
        );

    const iterate = async () => {
      const listBadgesResponse = await withResolvedError(
        requestFn(page * BADGES_LIST_PAGING_LIMIT),
        this.errorHandler,
        {
          errorCodesMap: {},
        },
      );
      page = page + 1;
      return listBadgesResponse?.data?.badges ?? [];
    };

    let badgesPage = await iterate();
    badgesAcc.push(...badgesPage);

    while (badgesPage.length > 0) {
      badgesPage = await iterate();
      badgesAcc.push(...badgesPage);
    }

    return badgesAcc;
  };
}
